module.exports = __webpack_public_path__ + "img/Desk Stationary A15.5c6e2e26.jpg";